import { Button, Icon, Input } from '@mairistem/composants';

const UuidInput = (props) => {
  const { value, onCopyClick, onPlug, onUnplug, plugged, loading } = props;

  return (
    <Input
      value={value}
      disabled={loading}
      readOnly
      action
      style={{ height: 35 }}
      title="Cet identifiant est unique et doit être utilisé dans l'application source pour lier les deux"
    >
      <input style={{ textAlign: 'center' }} data-testid="uuid-input" />
      <Button
        data-testid="copy-uuid-button"
        title="Copier l'identifiant dans le presse-papier"
        loading={loading}
        disabled={loading}
        icon={!loading && <Icon name="Copy" iconSet="Lucide" size={20} />}
        onClick={onCopyClick}
      />
      {plugged ? (
        <Button
          data-testid="unplug-button"
          title="Désactiver la liaison avec cette application"
          loading={loading}
          disabled={loading}
          icon={!loading && <Icon name="Unplug" iconSet="Lucide" size={20} />}
          onClick={onUnplug}
        />
      ) : (
        <Button
          data-testid="plug-button"
          title="Réactiver la liaison avec cette application"
          loading={loading}
          disabled={loading}
          icon={!loading && <Icon name="Plug" iconSet="Lucide" size={20} />}
          onClick={onPlug}
        />
      )}
    </Input>
  );
};

export default UuidInput;
